import { PrincipalType, type Account } from '../model/types';

// A tenant-level principal is the admin; clients (and machines) are scoped to a client.
export const isAdmin = (account: Account): boolean =>
  account.principalType === PrincipalType.Tenant;
